
import React from "react";
import { NewSubscriptionSection } from "./NewSubscriptionSection";
import { Subscription } from "@/types/subscription";
import { useAuth } from "@/context/AuthContext";

interface UserContentProps {
  onSubmit: (data: Omit<Subscription, "id" | "totalPaid">) => Promise<Subscription>;
  isLoading: boolean;
}

export function UserContent({ onSubmit, isLoading }: UserContentProps) {
  const { isAdmin } = useAuth();

  return (
    <NewSubscriptionSection
      onSubmit={onSubmit}
      isLoading={isLoading}
    />
  );
}
